import { render, staticRenderFns } from "./MofList.vue?vue&type=template&id=709fa075&scoped=true"
import script from "./MofList.vue?vue&type=script&lang=js"
export * from "./MofList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fa075",
  null
  
)

export default component.exports